exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".alert {\r\n    margin-top: 25px;\r\n}\r\n.affix {\r\n    top: 0;\r\n    width: 98%;\r\n    z-index: 1000;\r\n}\r\n\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/src/app/components/notify/notify.component.css
// module id = ../../../../../src/app/components/notify/notify.component.css
// module chunks = main